import React, { useMemo } from 'react';
import pickBy from 'lodash/pickBy';
import { useDispatch, useSelector } from 'react-redux';
import { DateUtils, TypeUtils } from '@vectord/utils';
import classNames from 'classnames';

import {
  isValidSbatGroupFilter,
  rescheduleClassesAppliedFiltersSelector,
  removeRescheduleFilter,
  RESCHEDULE_CLASSES_FILTERS,
  RESCHEDULE_CLASSES_FILTER_LABELS,
} from 'features/classCreation';
import styles from './RescheduleClassesFilterChips.module.scss';
import ToggleChip from 'components/ToggleChip';

function RescheduleClassesFilterChips() {
  const dispatch = useDispatch();
  const appliedFilters = useSelector(rescheduleClassesAppliedFiltersSelector);

  const filters = useMemo(() => {
    return pickBy(appliedFilters, isValidSbatGroupFilter);
  }, [appliedFilters]);

  const handleRemoveFilter = (filterKey) => {
    dispatch(removeRescheduleFilter(filterKey));
  };

  return Object.keys(filters).map((filterKey) => {
    let label = `${RESCHEDULE_CLASSES_FILTER_LABELS[filterKey]}: `;

    if (
      filterKey === RESCHEDULE_CLASSES_FILTERS.fromDate ||
      filterKey === RESCHEDULE_CLASSES_FILTERS.toDate
    ) {
      label = label + DateUtils.toDDMMMYYYY(filters[filterKey]);
    } else if (TypeUtils.isArray(filters[filterKey])) {
      const filterList = filters[filterKey]
        .map((filter) => filter.label)
        .join(', ');
      label = label + filterList;
    } else {
      label = label + filters[filterKey].label;
    }

    return (
      <ToggleChip
        key={filterKey}
        isAdded
        label={label}
        className={classNames(styles.root, 'h5 m-r-xxs')}
        onRemove={() => handleRemoveFilter(filterKey)}
      />
    );
  });
}

export default RescheduleClassesFilterChips;
